import { PLACEHOLDER } from './format';

/** Coloured pill for a building's A–G energy label; greys out when no label is present. */
export function EnergyBadge({ label }: { label: string | null }) {
  if (!label) return <span className="text-white/40">{PLACEHOLDER}</span>;
  const tone =
    label === 'A' || label === 'B'
      ? 'bg-emerald-500/20 text-emerald-300'
      : label === 'C' || label === 'D'
        ? 'bg-amber-500/20 text-amber-300'
        : 'bg-rose-500/20 text-rose-300';
  return <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${tone}`}>{label}</span>;
}
